<div class="secondEditorBox">
  <angular-editor [ngModel]="questionText" (ngModelChange)="changeValue($event)" [config]="editorConfig" class="limitedEditor">
  </angular-editor>
</div>